<template>
  <div id="app">
    <div class="container" v-if="totalOrPart == 2">
      <div class="header">
      <touBox></touBox>
      </div>
    <div class="content">
      <div class="left-menu">
        <leftBox v-if="menuType == 0"/>
        <Menu v-if="menuType == 1"></Menu>
      </div>
      <div class="right-content">
          <router-view :key="$route.fullPath"/>
      </div>
    </div>
  </div>
   <router-view v-if="totalOrPart == 1"/>
  </div>
</template>

<script>
import leftBox from './views/homePage/leftBox/leftBox'
import Menu from './views/homePage/leftBox/menu.vue'
import touBox from './views/homePage/headerBox/touBox.vue'
import { mapGetters } from 'vuex'
import '@/styles/global.scss'
import '@/styles/index.scss'
export default {
  computed: {
    ...mapGetters([
      'menuType', 'totalOrPart', 'headerBg'
    ])
  },
  components: {
    touBox, leftBox, Menu
  },
  name: 'App',
  data () {
    return {

    }
  },
  created () {


  },
  watch: {
    headerBg (newval) {
      const root = document.documentElement;
      root.style.setProperty('--themeColor', newval);
    }
  },
  mounted () {
    //默认色设置
    const root = document.documentElement;
    root.style.setProperty('--themeColor', this.headerBg);
    root.style.setProperty('--themeLightColor', `${this.headerBg}01`);
  }
}
</script>

<style lang="scss">
html,
body {
  width: 100vw;
  height: 100vh;
  // color: rgba(255, 255, 255, .8);
  background-color: #ffffff;
}

* {
  box-sizing: border-box;
}

li {
  list-style: none;
}

li:hover {
  cursor: pointer;
}

.header {
  height: 60px;
  min-height: 60px;
}

.container {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
  }

  .content {
    display: flex;
    height: calc(100vh - 60px);

    .left-menu {
      height: calc(100vh - 60px);
    }

    .right-content {
      flex: 1;
      // padding: 10px;
      overflow: scroll;
    }
  }
}


.el-aside .el-form-item {
   margin-bottom: 10px !important;
}
.form-widget-list .el-form-item{
  margin-bottom: 0 !important ;
}

.el-form-item__content {
  display: flex !important;
  margin: 0 !important;

}


::v-deep .vue-treeselect {
  line-height: 35px !important;
}

.design-time-bottom-margin {
  margin: 0;
}

input {
  outline: none;
}

textarea {
  outline: none;
}

//定义
:root {
  --themeColor: yellow;
}

.el-input__inner:focus {
  border: 1px solid var(--themeColor) !important; //边框颜色
  border-radius: 5px;
}

.el-tabs__item.is-active {
  color: var(--themeColor) !important;
}

.el-tabs__item:hover {
  color: var(--themeColor) !important;
}

.el-tabs__active-bar.is-top {
  color: var(--themeColor) !important;
}

.el-tabs__active-bar {
  background-color: var(--themeColor) !important;
}



.act-item {
  border-bottom: 3px solid var(--themeColor) !important;
}

.el-button--primary,
.el-button--primary:hover,

.el-button--primary.is-active,
.el-button--primary:active,
.el-button--primary:focus {
  background-color: var(--themeColor) !important;
  border-color: var(--themeColor) !important;
  color: #fff !important;
}

.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: var(--themeColor) !important;
  border-color: var(--themeColor) !important;
  box-shadow: -1px 0 0 0 var(--themeColor) !important;
}

.ant-btn-primary {
  background-color: var(--themeColor) !important;
  border-color: var(--themeColor) !important;
}

.ant-switch-checked {
  background-color: var(--themeColor) !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--themeColor) !important;
  border-color: var(--themeColor) !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--themeColor) !important;
  border-color: var(--themeColor) !important;
}

.el-select-dropdown__item.selected {
  color: var(--themeColor) !important;
}

.el-aside {

  .el-tabs,
  .el-tabs--top {
    width: 100% !important;
  }
}

.el-switch.is-checked .el-switch__core {
  border-color: var(--themeColor) !important;
  background-color: var(--themeColor) !important;
}

.el-tree-node__content:hover,
.el-upload-list__item:hover .el-tree-node__label {
  background-color: var(--themeColor) !important;
  color: #fff !important;
}

.el-tree-node:focus>.el-tree-node__content {
  background-color: var(--themeColor) !important;
  color: #fff !important;
}

.el-checkbox__inner:hover {
  border-color: var(--themeColor) !important;
}

.el-button--default {
  color: #606266 !important;
  background-color: #fff !important;
  border-color: #DCDFE6 !important;
}


.el-table__footer-wrapper,
.el-table__header-wrapper {
  height: 45px;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--themeColor) !important;
}

.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: var(--themeColor) !important;
}

.global-labels {
  .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 0.125rem !important;
    width: 200px !important;
  }
}

.el-dialog {
  .el-input__inner {
    height: 35px !important;
    line-height: 35px !important;
    border-radius: 0.125rem !important;
    width: 230px !important;
  }

  .el-form-item {
    margin-bottom: 0;
    padding-top: 20px !important;
  }

  .el-radio-group {
    padding-top: 12px !important;
  }
}
.mformdesign{
  .el-input__inner {
    width: 100% !important;
  }
  .el-form-item{
    padding-top: 0 !important;

  }
}
.showSelect{
  .el-input__inner {
    height: 33px !important;
    line-height: 33px !important;
    border-radius: 50px !important;
    width: 100% !important;
  }

}
.el-radio__input.is-checked .el-radio__inner {
  border-color: var(--themeColor) !important;
  background: var(--themeColor) !important;
}

.el-radio__input.is-checked+.el-radio__label {
  color: var(--themeColor) !important;
}

.el-popover {
  min-width: 80px !important;
  padding: 4px 0 !important;
}

.vue-treeselect__option {
  /* 自定义选项的样式 */
  background-color: #fff !important;
  /* 修改背景颜色 */
  color: #606266 !important;
  /* 修改文字颜色 */
  /* 其他样式属性 */
}

.vue-treeselect__multi-value-item {
  color: var(--themeColor) !important;
}

.vue-treeselect__value-remove {
  color: var(--themeColor) !important;
}

.vue-treeselect__checkbox {
  border-color: var(--themeColor) !important;
}

.vue-treeselect__checkbox.vue-treeselect__checkbox--checked:before {
  background-color: var(--themeColor) !important;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: var(--themeColor) !important;
}

.vue-treeselect__control {}



.vue-treeselect__control {
  width: 230px !important;
  border-radius: 0.125rem !important;

}



::v-deep .vue-treeselect__input {
  /* 自定义输入框的样式 */
  /* background-color: #f2f2f2; */
  /* 修改背景颜色 */
  /* color: #333; */
  /* 修改文字颜色 */
  /* 其他样式属性 */
}

::v-deep .vue-treeselect__menu {
  /* 自定义下拉菜单的样式 */
  background-color: #fff !important;
  /* 修改背景颜色 */
  color: #333 !important;
  /* 修改文字颜色 */
  /* 其他样式属性 */
}

.avatar-uploader .el-upload:hover {
  border-color: var(--themeColor) !important;
}

.el-date-table td.today span {
  color: var(--themeColor) !important;
}

.el-date-table td.available:hover {
  color: var(--themeColor) !important;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}



.vue-treeselect {
  line-height: 35px !important;
}

.searchTree>.vue-treeselect__control {
  height: 32px !important;
  margin-top: 4px;
  // line-height: 32px !important;
  width: 200px !important;

}

.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--themeColor) !important;
}
.el-table th.el-table__cell>.cell{
  padding-left: 14px !important;
 

}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color:var(--themeColor) !important;
    color: #fff !important;
}
.el-loading-spinner .path{
  stroke:var(--themeColor) !important;
}
 .bg_blue {
  background-color: var(--themeColor) !important;
  color: #fff !important;
} 
.el-loading-spinner .el-loading-text{
  color: var(--themeColor) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue